import MergeDirectoryPreview from './MergeDirectoryPreview';
export default MergeDirectoryPreview;